function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19430"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59554",
    d: "M22.528 17.45H19.5a2.048 2.048 0 0 0-2.05 2.05v3.031a2.049 2.049 0 0 0 2.05 2.044h3.031a2.049 2.049 0 0 0 2.047-2.047V19.5a2.049 2.049 0 0 0-2.05-2.05zm.839 5.078a.845.845 0 0 1-.839.839H19.5a.845.845 0 0 1-.839-.839V19.5a.841.841 0 0 1 .839-.839h3.031a.841.841 0 0 1 .839.839z",
    transform: "translate(-8.575 -8.575)",
    style: {
      fill: "#0a243f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59555",
    d: "M22.528 2.75H19.5a2.048 2.048 0 0 0-2.05 2.05v3.028a2.048 2.048 0 0 0 2.05 2.047h3.031a2.049 2.049 0 0 0 2.047-2.047V4.8a2.049 2.049 0 0 0-2.05-2.05zm.839 5.078a.841.841 0 0 1-.839.839H19.5a.841.841 0 0 1-.839-.839V4.8a.845.845 0 0 1 .839-.839h3.031a.845.845 0 0 1 .839.839z",
    transform: "translate(-8.575 -2.75)",
    style: {
      fill: "#0a243f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59556",
    d: "M7.828 17.45H4.8a2.049 2.049 0 0 0-2.05 2.05v3.031a2.049 2.049 0 0 0 2.05 2.044h3.028a2.048 2.048 0 0 0 2.047-2.047V19.5a2.049 2.049 0 0 0-2.047-2.05zm.839 5.078a.841.841 0 0 1-.839.839H4.8a.845.845 0 0 1-.839-.839V19.5a.841.841 0 0 1 .839-.839h3.028a.837.837 0 0 1 .839.839z",
    transform: "translate(-2.75 -8.575)",
    style: {
      fill: "#0a243f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59557",
    d: "M7.828 2.75H4.8A2.049 2.049 0 0 0 2.75 4.8v3.028A2.048 2.048 0 0 0 4.8 9.875h3.028a2.048 2.048 0 0 0 2.047-2.047V4.8a2.049 2.049 0 0 0-2.047-2.05zm.839 5.078a.837.837 0 0 1-.839.839H4.8a.841.841 0 0 1-.839-.839V4.8a.845.845 0 0 1 .839-.842h3.028a.841.841 0 0 1 .839.839z",
    transform: "translate(-2.75 -2.75)",
    style: {
      fill: "#0a243f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridview);
export default __webpack_public_path__ + "static/media/gridview.7ad33506335db88647e36f2f6ded6975.svg";
export { ForwardRef as ReactComponent };